import LinedInput, {InputType} from "./LinedInput";
export {InputType};
export default LinedInput;
